/* @flow strict */

import * as React from 'react';

import './styles.scss';

type PropsType = {
  label?: string | React.Node,
  style?: {},
  name?: string,
  component?: string | React.Node,
  checked?: boolean,
  callBack?: (boolean) => void
};

const SimpleCheckbox = (props: PropsType): React.Element<'div'> => {
  const [checked, toggleCheck] = React.useState(props.checked || false);
  React.useEffect(() => {
    toggleCheck(props.checked)
  }, [props.checked])

  const _toggleCheck = () => {
    if (props.callBack) {
      props.callBack(!checked);
    }

    toggleCheck(!checked);
  };

  return (
    <div className="form-group" style={props.style ? { ...props.style } : {}}>
      <label className="icheckbox">
        <input
          type="checkbox"
          checked={checked}
          name={props.name ? props.name : 'simple'}
          onChange={_toggleCheck}
        />
        <i className="icheckbox-icon" />

        {props.label ? <span>{props.label}</span> : null}


        {props.component ? props.component : null}
      </label>
    </div>
  );
};

export default SimpleCheckbox;
